import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';

@Injectable({
  providedIn: 'root'
})
export class ShipmentAuditTrailService extends DataService {

  public observable$: any;

  constructor(http: HttpClient) {
    super(http);
    this.setUri(this.baseURI);
  }

  private baseURI = this.apiUri + '/auditTrail/';

  // Function to get the AuditTrail Log list by shipmentId
  getAuditTrailListByShipmentId(shipmentId: number): Observable<any> {
    const auditTrailListUrl = this.baseURI + shipmentId + '/shipmentId';
    console.log('shipmentId in audittrail : ' + shipmentId);
    if (shipmentId + '' !== undefined) {
      this.setUri(auditTrailListUrl);
      return this.get();
    }
  }

  getAuditTrailListByOrgId(orgId: number): Observable<any> {
    const auditTrailListUrl = this.baseURI + orgId + '/orgId';
    console.log('shipmentId in audittrail : ' + orgId);
    if (orgId + '' !== undefined) {
      this.setUri(auditTrailListUrl);
      return this.get();
    }
  }

  // getAuditTrailListByCarIDAndScopeType(carrierId: number, scopeType: string): Observable<any> {
  //   const auditTrailListUrl = this.apiUri+ '/ratescope/' + carrierId + '/carrierId/' + scopeType + '/scopeType/scopeAuditTrail';
  //   console.log('shipmentId in audittrail : ' + carrierId + 'scopeType' +scopeType);
  //   if (carrierId !== undefined && scopeType !== undefined) {
  //     this.setUri(auditTrailListUrl);
  //     return this.get();
  //   }
  // }

  getAuditTrailListByOrgIdAndUpdateProgram(orgId: number, updateProgram: string): Observable<any> {
    const auditTrailListUrl = this.baseURI + orgId + '/orgId/' + updateProgram + '/updateProgram';
    console.log('shipmentId in audittrail : ' + orgId + ' - ' + updateProgram);
    if (orgId + '' !== undefined) {
      this.setUri(auditTrailListUrl);
      return this.get();
    }
  }

  getAuditTrailListByUpdateProgramAndOrganizationIdAndUpdateId(updateProgram: string, orgId: number): Observable<any> {
    const auditTrailListUrl = this.baseURI + orgId + '/orgId/' + updateProgram + '/updateProgram/updateId';
    console.log('shipmentId in audittrail : ' + updateProgram);
    if (updateProgram + '' !== undefined) {
      this.setUri(auditTrailListUrl);
      return this.get();
    }
  }

  getAuditTrailListByUpdateProgram(updateProgram: string): Observable<any> {
    const auditTrailListUrl = this.baseURI + updateProgram + '/updateProgram';
    console.log('shipmentId in audittrail : ' + updateProgram);
    if (updateProgram + '' !== undefined) {
      this.setUri(auditTrailListUrl);
      return this.get();
    }
  }
}
